import React from 'react';
import {Switch} from "antd";
import DeleteBox from "../../microComponents/tablePages/DeleteBox";


const PalletStatusColumn = () => {


    const columns = [{
        className: 'hidden',
        title: 'ردیف', dataIndex: 'row', key: 'row', render: (text, row, index) => {
            return index + 1;
        },
    },

        {
            title: ' شناسه پالت', hidden: true,

            dataIndex: 'palletId',
            key: 'palletId',
        }, {
            title: 'محصول',
            dataIndex: 'productName',
            key: 'productName',
        },
        {
            title: ' تعداد در پالت',
            dataIndex: 'numberPerPallet',
            key: 'numberPerPallet'
        }, {
            title: 'ق.ت',
            dataIndex: 'manufacturerPriceRials',
            key: 'manufacturerPriceRials',
        }, {
            title: ' ق.م',
            dataIndex: 'consumerPriceRials',
            key: 'consumerPriceRials',
        },

        {
            title: '  تاریخ تولید',
            dataIndex: 'dateOfManufacure',
            key: 'dateOfManufacure',
        }, {
            title: 'تاریخ انقضا',
            dataIndex: 'expireDate',
            key: 'expireDate',

        }, {
            title: ' QC',
            dataIndex: 'qcStatus',
            key: 'qcStatus',

        },{
			title: 'بچ',
			dataIndex: 'batchNumber',
			key: 'batchNumber',

		}, {
			title: 'کاربر',
			dataIndex: 'addBy',
			key: 'addBy',
		}, {
            fixed: 'right',
            title: 'بارگیری',
            dataIndex: 'allowLoad',
            key: 'allowLoad', render: (item, row) => {
                return <Switch disabled onClick={() => {

                }} checked={item} unCheckedChildren='نشود'
                               className='bg-amber-600'
                               checkedChildren='شود'/>

            }
        },
        {
            fixed: 'right',
            title: 'عملیات',
            // className: 'hidden xl:block',
            dataIndex: 'events',
            key: 'events',
            render: (x, row) => {
                return <div className='flex gap-1'>

                    <DeleteBox rowData={row} />
                </div>


            }
        },


    ];
    return [columns];
};

export default PalletStatusColumn;